import React from 'react';

import { LayoutWrapper } from './layout-wrapper';
import { LayoutWithoutHeader } from './layout-without-header';

type EnterpriseLayoutProps = {
  children: React.ReactNode;
};

/**
 * EnterpriseLayout - Layout component for enterprise pages
 * Similar to EnterpriseProductLayout but designed for general enterprise pages like signup
 */
export function EnterpriseLayout({ children }: EnterpriseLayoutProps): JSX.Element {
  return (
    <LayoutWrapper>
      <LayoutWithoutHeader hideFooter>
        {/* Enterprise pages are dispensary-independent and don't need headers/footers */}
        {children}
      </LayoutWithoutHeader>
    </LayoutWrapper>
  );
}
